import { useEffect, useState } from 'react';
import { Card, CardContent } from '../ui/card';
import { Input } from '../ui/input';
import { Button } from '../ui/button';
import { Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { errMsg } from '../guias/guiasUtils';


export const Retroativo = ({ api, onClose, onDone }) => {
  const [inicio, setInicio] = useState('');
  const [prev, setPrev] = useState(null);
  const [busy, setBusy] = useState(false);
  const [confirmar, setConfirmar] = useState(false);

  useEffect(() => {
    let ativo = true;
    setPrev(null); setConfirmar(false);
    api.get('/primeiros-atendimentos/retroativo/preview', { params: inicio ? { inicio } : {} }).then((r) => { if (ativo) setPrev(r.data); }).catch((e) => { if (ativo) toast.error(errMsg(e, 'Erro ao levantar admissões')); });
    return () => { ativo = false; };
  }, [api, inicio]);

  const gerar = async () => {
    setBusy(true);
    try {
      const r = (await api.post('/primeiros-atendimentos/retroativo', { inicio: inicio || null, confirmacao: 'GERAR' })).data;
      toast.success(`${r.pendencias_criadas} pendência(s) criadas para ${r.internacoes} admissão(ões); responsáveis notificados`);
      onDone?.(); onClose();
    } catch (e) { toast.error(errMsg(e, 'Erro ao gerar pendências')); } finally { setBusy(false); }
  };

  return (
    <Card data-testid="pa-retroativo"><CardContent className="p-4 space-y-3">
      <div>
        <p className="text-sm font-medium">Regularizar pacientes já admitidos (Fisioterapia, Fonoaudiologia, Nutrição e Psicologia)</p>
        <p className="text-xs text-muted-foreground">Cria somente as pendências de primeira avaliação ausentes nos pacientes ativos do Kanban e notifica. Não duplica, não altera avaliações concluídas, não cria vínculo e não mexe na Clínica Médica.</p>
      </div>
      <div className="flex flex-wrap items-center gap-2">
        <span className="text-sm">Admissões a partir de (opcional)</span>
        <Input type="date" className="w-44" value={inicio} onChange={(e) => setInicio(e.target.value)} data-testid="pa-retroativo-inicio" />
      </div>
      {prev && (
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 text-sm" data-testid="pa-retroativo-total">
          <div className="rounded border p-2"><p className="text-xs text-muted-foreground">Pacientes ativos</p><p className="font-semibold" data-testid="pa-retro-ativos">{prev.pacientes_ativos}</p></div>
          <div className="rounded border p-2"><p className="text-xs text-muted-foreground">Pendências existentes</p><p className="font-semibold" data-testid="pa-retro-existentes">{prev.pendencias_existentes}</p></div>
          <div className="rounded border p-2"><p className="text-xs text-muted-foreground">Pendências ausentes</p><p className="font-semibold text-amber-700" data-testid="pa-retro-ausentes">{prev.pendencias_ausentes}</p></div>
          <div className="rounded border p-2"><p className="text-xs text-muted-foreground">Registros a criar ({prev.total} admissão(ões))</p><p className="font-semibold text-emerald-700" data-testid="pa-retro-criar">{prev.pendencias_previstas}</p></div>
        </div>)}
      <div className="flex flex-wrap items-center gap-2">
      </div>
      {prev?.internacoes?.length > 0 && (
        <ul className="max-h-40 overflow-y-auto text-xs space-y-1 border rounded p-2" data-testid="pa-retroativo-lista">
          {prev.internacoes.map((i) => (
            <li key={i.internacao_id} className="flex flex-wrap gap-x-2">
              <span className="font-medium">{i.paciente_nome || '—'}</span><span className="text-muted-foreground">#{i.numero_prontuario || '—'} · admissão {i.data_admissao}</span>
              <span className="text-emerald-700">criar: {i.faltam.join(', ')}</span>
              {i.sem_profissional.length > 0 && <span className="text-amber-700">(sem especialista no Kanban: {i.sem_profissional.join(', ')})</span>}
            </li>))}
        </ul>)}
      {prev?.ultima_execucao && <p className="text-xs text-muted-foreground" data-testid="pa-retroativo-ultima">Última ativação: {new Date(prev.ultima_execucao.em).toLocaleString('pt-BR')} por {prev.ultima_execucao.usuario_nome} · {prev.ultima_execucao.pendencias_criadas} pendência(s)</p>}
      {confirmar && prev && (
        <div className="rounded-md border border-amber-300 bg-amber-50 p-3 text-sm text-amber-900" data-testid="pa-retroativo-confirmacao">
          <p className="font-medium">Confirmar regularização{inicio ? ` (admissões a partir de ${inicio.split('-').reverse().join('/')})` : ' (todos os pacientes ativos)'}?</p>
          <p className="text-xs mt-1">Serão criados <b>{prev.pendencias_previstas}</b> registro(s) de primeira avaliação em <b>{prev.total}</b> admissão(ões), com notificação aos responsáveis e à coordenação. Avaliações já existentes não são alteradas.</p>
        </div>)}
      <div className="flex gap-2">
        {!confirmar
          ? <Button size="sm" onClick={() => setConfirmar(true)} disabled={busy || !prev || prev.total === 0} data-testid="pa-retroativo-gerar">Gerar pendências e notificar</Button>
          : <Button size="sm" onClick={gerar} disabled={busy} className="bg-amber-700 hover:bg-amber-800" data-testid="pa-retroativo-confirmar">{busy && <Loader2 className="h-4 w-4 mr-2 animate-spin" />}Confirmar criação de {prev?.pendencias_previstas} registro(s)</Button>}
        <Button size="sm" variant="ghost" onClick={onClose} data-testid="pa-retroativo-fechar">Fechar</Button>
      </div>
    </CardContent></Card>
  );
};
